<template lang="pug">
div
  template(v-if="![41, 42, 43, 44, 45, 46, 47, 49, 51].includes(menu2)")
    .odd-box(@click="placeBet($event.target)")
      .odd.center(:class="cssClass")
        template(v-if="['hdp','hdph','ou','ouh'].includes(mode)")
          .odd-point {{ showOdds(mode.toUpperCase(), homeAway, details[mode][count][7], details[mode][count][8]) }}
        template(v-else-if="['orz'].includes(mode)")
          .outright-team {{ label }}
        .odd-value(:class="valueClass") {{ value }}
  template(v-else)
    .bettype-col(v-if="[45, 46, 49].includes(menu2) && label") {{ $t("m.GH_" + label.toUpperCase()) }}
    .bettype-col(v-if="[51].includes(menu2) && label") {{ $t("m.GX_" + label.toUpperCase()) }}
    .odds.odd-value(:class="valueClass" @click="placeBet($event.target)") {{ value }}
</template>

<script>
import config from "@/config";
import naming from "@/library/_name";
import { EventBus } from "@/library/_event-bus.js";

export default {
  props: {
    details: {
      type: [Object, Array]
    },
    odds: {
      type: Array
    },
    idx: {
      type: String
    },
    typ: {
      type: String
    },
    cls: {
      type: String
    },
    dataType: {
      type: String
    },
    mode: {
      type: String
    },
    count: {
      type: [Number, String]
    },
    homeAway: {
      type: String
    },
    label: {
      type: String
    }
  },
  data() {
    return {
      trigger: false,
      timer: null,
      old: null,
      dir: null,
      defStake: "",
      newPage: true
    };
  },
  computed: {
    menu0() {
      return this.$store.getters.menu0;
    },
    menu1() {
      return this.$store.getters.menu1;
    },
    menu2() {
      return this.$store.getters.menu2;
    },
    menu3() {
      return this.$store.getters.menu3;
    },
    betType() {
      return this.$store.state.layout.menu3;
    },
    id() {
      return this.odds[3];
    },
    value() {
      return this.odds[this.idx];
    },
    cssClass() {
      if (this.dir != null) {
        return this.dir;
      }
    },
    dv() {
      var idx = parseInt(this.idx);
      switch (this.dataType) {
        case "1": // HDP/OU
          idx = parseInt(this.idx) + 16;
          return parseFloat(this.odds[idx]);
          break;
        case "2": // OE/ML/1X2
          idx = parseInt(this.idx) + 16;
          return parseFloat(this.odds[idx]);
          break;
        default:
          return parseFloat(this.odds[idx]);
          break;
      }
    },
    valueClass() {
      var result = [];
      if (this.cls) {
        result.push(this.cls);
      }
      if (!this.allowBet) {
        result.push("nb");
      }
      if (this.value < 0) {
        result.push("negative");
      }
      return result;
    },
    allowBet() {
      switch (this.dataType) {
        case "1":
          return this.odds[15] == 1;
        case "2":
          return this.odds[10] == 1;
        case "3":
          return this.odds[9] == 1;
        case "4":
          return this.odds[9] == 1;
      }
      return false;
    },
    pause() {
      switch (this.dataType) {
        case "1":
          return this.odds[14] == 1;
        case "2":
          return this.odds[9] == 1;
        case "3":
          return false;
        case "4":
          return false;
      }
      return true;
    },
    mixParlay() {
      switch (this.dataType) {
        case "1": // HDP/OU
          return this.odds[13] == 1;
        case "2": // OE/ML/1X2
          return this.odds[8] == 1;
        case "3": // CS/DC...
          return this.odds[8] == 1;
        case "4": // OUTRIGHT
          return this.odds[8] == 1;
      }
      return false;
    }
  },
  watch: {
    dv(newVal, oldVal) {
      var nv = newVal;
      var ov = oldVal;
      if (nv == "" || nv == 0) {
        this.trigger = false;
        this.dir = null;
        return;
      } else {
        if (ov != nv) {
          this.trigger = true;
          if (nv < 0) {
            if (ov < nv) {
              this.dir = "odd-drop";
            } else {
              this.dir = "odd-rise";
            }
          } else {
            if (ov > nv) {
              this.dir = "odd-drop";
            } else {
              this.dir = "odd-rise";
            }
          }
          setTimeout(() => {
            this.trigger = false;
            this.dir = null;
          }, 10000);
        }
      }
      this.old = oldVal;
    },
    id(newVal, oldVal) {
      this.reset();
    },
    typ(newVal, oldVal) {
      this.reset();
    },
    betType(newVal, oldVal) {
      this.reset();
    },
    menu0() {
      this.reset();
    },
    menu1() {
      this.reset();
    },
    menu2() {
      this.reset();
    },
    menu3() {
      this.reset();
    }
  },
  methods: {
    reset() {
      this.trigger = false;
      this.old = null;
      this.dir = null;
    },
    placeBet(e) {
      $(".odd-value").removeClass("selected-odds");
      if (this.allowBet) {
        if (this.$store.state.layout.betting.defaultStake == "0") {
          this.defStake = this.$store.state.layout.betting.defaultStakeAmount;
        } else {
          this.defStake = 5;
        }
        if (this.betType != "parlay") {
          setTimeout(() => {
            $(e).addClass("selected-odds");
          }, 10);
          if (EventBus.betSingle) {
            EventBus.betSingle(this.odds, this.typ, this.idx, this.value, this.betType, this.defStake, this.mixParlay, null, e);
          }
        } else {
          if (this.mixParlay) {
            // if (Object.keys(this.$store.state.betparlay).length + 1 <= config.parlayMaxTicket) {
              if (EventBus.betParlay) {
                EventBus.betParlay(this.odds, this.typ, this.idx, this.value, this.betType, this.defStake);
              }
            // } else {
            //   this.$helpers.showDialog(this.$t("ui.action"), this.$t("error.maxParlayTicket"), "info");
            // }
          }
        }
      }
    },
    showOdds(bet_type, home_away, giving, odds) {
      return naming.ballDisplay3(odds, giving, home_away, bet_type, this);
    }
  }
};
</script>
